var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.pageComponent,{tag:"Component",attrs:{"article":_vm.article}})
}
var staticRenderFns = []

export { render, staticRenderFns }